import Vue from 'vue'
import VueCookies from 'vue-cookies'
import authorizeConstants from '../../constants/authorizeConstants'
Vue.use(VueCookies)

const authorization = {
  mutations: {
    setAccessToken: function (state, accessToken) {
      if (accessToken) {
        window.sessionStorage.setItem(authorizeConstants.SESSION_ACCESS_TOKEN_KEY, accessToken)
      }
    },
    deleteAccessToken: function (state) {
      window.sessionStorage.removeItem(authorizeConstants.SESSION_ACCESS_TOKEN_KEY)
      Vue.cookies.remove(authorizeConstants.ACCESS_TOKEN_KEY)
      Vue.cookies.remove(authorizeConstants.LEGACY_ACCESS_TOKEN_KEY)
      Vue.cookies.remove(authorizeConstants.REFRESH_TOKEN_KEY)
    }
  },
  actions: {
    loadAuthorization: function (context) {
      return new Promise((resolve, reject) => {
        const sessionAccessToken = window.sessionStorage.getItem(authorizeConstants.SESSION_ACCESS_TOKEN_KEY)
        if (sessionAccessToken) {
          resolve(sessionAccessToken)
          return
        }
        const accessTokenKey = authorizeConstants.ACCESS_TOKEN_KEY
        const accessToken = Vue.cookies.get(accessTokenKey)
        if (accessToken) {
          context.commit('setAccessToken', accessToken)
          resolve(accessToken)
        } else {
          const legacyAccessToken = Vue.cookies.get(authorizeConstants.LEGACY_ACCESS_TOKEN_KEY)
          if (legacyAccessToken) {
            context.commit('setAccessToken', legacyAccessToken)
            resolve(legacyAccessToken)
            return
          }
          const refreshTokenKey = authorizeConstants.REFRESH_TOKEN_KEY
          const refreshToken = Vue.cookies.get(refreshTokenKey)
          if (refreshToken) {
            Vue.prototype.$ajax({
              url: '/index/m/ws/login/refreshToken',
              method: 'post',
              data: Vue.prototype.$qs.stringify({
                refreshToken: refreshToken
              })
            }).then(result => {
              const refreshAccessToken = Vue.cookies.get(authorizeConstants.LEGACY_ACCESS_TOKEN_KEY)
              if (refreshAccessToken) {
                context.commit('setAccessToken', refreshAccessToken)
                resolve(refreshAccessToken)
              } else {
                reject(new Error(authorizeConstants.ERROR_TYPE.REFRESH_TOKEN_FAULT))
              }
            }, () => {
              reject(new Error(authorizeConstants.ERROR_TYPE.SERVER_ERROR))
            })
          } else {
            reject(new Error(authorizeConstants.ERROR_TYPE.NONE_REFRESH_TOKEN))
          }
        }
      })
    }
  }
}

export default authorization
